module.exports = __webpack_public_path__ + "static/media/cs197_chexmera.81a1acb2.png";